'use client';

import React from 'react';
import { Image } from '@packages/shared/src/ui/Image/Image';

export type BrandImageProps = {
  image?: string;
  name?: string;
};

export const brandImageSize = 56;

/**
 * component to display a product brand image with an optional link if available
 *
 * concept: The brand image should have the dimensions from the image that gets loaded. But it must have a maximum size of 52px x 52px.
 * It should be centered horizontal and vertical.
 */
export const BrandImage = ({ image, name }: BrandImageProps) => {
  const [brandImage, setBrandImage] = React.useState(image || null);

  if (!name || brandImage === null) return null;

  return (
    <div className="max-h-[56px] w-[56px]">
      <Image
        src={brandImage}
        alt={name}
        width={brandImageSize}
        height={brandImageSize}
        className="m-auto block size-auto max-h-[56px] max-w-[56px] object-contain"
        onError={() => setBrandImage(null)}
      />
    </div>
  );
};
